import edBeluga from './Initial/edBeluga';
import ed from './Initial/ed';
import edus from './Initial/edus';
import edBelugaMonthly from './followup/edBelugaMonthly';

const EDQuestions = [...edBeluga, ...ed, ...edus, ...edBelugaMonthly];
export default EDQuestions;
